// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, Popup } from 'semantic-ui-react';
// local
// consts
import { CYLINDER_STATE, CYLINDER_PRESSURE_MAP } from 'salvus-shared/consts/cylinder';
// images
import ic_delivery_today from 'app/_assets/img/ic_delivery_today.png';
import ic_delivery_today_white from 'app/_assets/img/ic_delivery_today_white.png';
import ic_delivery_tomorrow from 'app/_assets/img/ic_delivery_tomorrow.png';
import ic_delivery_tomorrow_white from 'app/_assets/img/ic_delivery_tomorrow_white.png';
// css
import './PressureBar.css';

class PressureBar extends Component {
    constructor(props) {
        super(props);
        this.state = this.initState(props);
    }

    initState({ cylinderSize }) {
        if (cylinderSize) {
            const cylinderInfo = CYLINDER_PRESSURE_MAP[cylinderSize];
            const maxPressure = cylinderInfo.p;
            return {
                maxPressure,
                yellowPressure: maxPressure * 0.7,
                redPressure: maxPressure * 0.45,
            };
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.cylinderSize !== this.props.cylinderSize) {
            this.setState(this.initState(nextProps));
        }
    }

    renderScheduled(state) {
        let src = this.props.inAlert ? ic_delivery_tomorrow_white : ic_delivery_tomorrow;
        let iconClass = 'tomorrow';
        if (state === CYLINDER_STATE.REQUESTED) {
            src = this.props.inAlert ? ic_delivery_today_white : ic_delivery_today;
            iconClass = 'today';
        }
        return (
            <div className={`pressure-bar scheduled ${this.props.small ? 'small' : ''}`}>
                <div className="circle">
                    <Image src={src} className={iconClass} />
                </div>
            </div>
        );
    }

    renderCircle(type) {
        return (
            <div className={`pressure-bar ${type} ${this.props.small ? 'small' : ''}`}>
                <div className="circle">
                    <div className="mask" />
                </div>
            </div>
        );
    }

    renderCurrent(pressure) {
        const { maxPressure, yellowPressure, redPressure } = this.state;
        pressure = Math.max(Math.min(pressure, maxPressure), 50);
        const top = -1 * ((pressure * 32) / maxPressure);
        let colorCls = 'green';
        if (pressure < yellowPressure && pressure >= redPressure) {
            colorCls = 'yellow';
        } else if (pressure < redPressure) {
            colorCls = 'red';
        }
        return (
            <div className={`pressure-bar ${colorCls} ${this.props.small ? 'small' : ''}`}>
                <div className="circle">
                    <div className="mask" style={{ top }} />
                </div>
            </div>
        );
    }

    render() {
        let { pressure, state } = this.props;
        let trigger = null;
        let content = null;
        switch (state) {
            case CYLINDER_STATE.REQUESTED:
                content = 'Solicitação agendada';
                trigger = this.renderScheduled(state);
                break;
            case CYLINDER_STATE.PENDING:
                content = 'Solicitação pendente';
                trigger = this.renderScheduled(state);
                break;
            case CYLINDER_STATE.FULL:
                content = 'Cheio';
                trigger = this.renderCircle('full');
                break;
            case CYLINDER_STATE.CURRENT:
                content = `${pressure}`;
                trigger = this.renderCurrent(pressure);
                break;
            default:
                content = 'Vazio';
                trigger = this.renderCircle('empty');
                break;
        }

        return <Popup trigger={trigger} content={content} size="tiny" inverted />;
    }
}

PressureBar.defaultProps = {
    small: false,
};

PressureBar.propTypes = {
    pressure: PropTypes.number,
    state: PropTypes.number,
    inAlert: PropTypes.bool,
    cylinderSize: PropTypes.number,
    small: PropTypes.bool,
};

export default PressureBar;
